import { useId } from "react";
import Form from "react-bootstrap/Form";

/**
 * Vitrin / Arşiv style toggle, aligned with the admin action row.
 *
 * Falls back to a generated id so the label is actually bound to the input —
 * without one, react-bootstrap renders no htmlFor and clicking the label does nothing.
 */
export default function AdminSwitch({ label, checked, onChange, id }) {
  const generatedId = useId();

  return (
    <Form.Check
      type="switch"
      id={id || generatedId}
      className="admin-switch"
      label={label}
      checked={!!checked}
      onChange={onChange}
    />
  );
}
